import { render, staticRenderFns } from "./SundrySupplierProfile.vue?vue&type=template&id=88c28300&"
import script from "./SundrySupplierProfile.vue?vue&type=script&lang=js&"
export * from "./SundrySupplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./SundrySupplierProfile.vue?vue&type=style&index=0&id=88c28300&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports